import { render, staticRenderFns } from "./PhoneLink.vue?vue&type=template&id=a0f54a82&scoped=true"
import script from "./PhoneLink.vue?vue&type=script&lang=js"
export * from "./PhoneLink.vue?vue&type=script&lang=js"
import style0 from "./PhoneLink.vue?vue&type=style&index=0&id=a0f54a82&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f54a82",
  null
  
)

export default component.exports